var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.19,4.23a.51.51,0,0,0,0-.71l-.36-.36a.5.5,0,0,0-.7,0l-3.3,3.21-.06-4.88a.51.51,0,0,0-.5-.49h-.52a.51.51,0,0,0-.5.49L17.17,7H3A2,2,0,0,0,1,9V20a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V9a2,2,0,0,0-2-2h-.51ZM17,19a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V10A1,1,0,0,1,4,9H16a1,1,0,0,1,1,1Zm4-4.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5ZM20.5,9a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f4d778d692d7f245f4b5281905c0504e.svg";
export { ForwardRef as ReactComponent };